import { render, staticRenderFns } from "./raca.vue?vue&type=template&id=3a875f08&"
import script from "./raca.vue?vue&type=script&lang=js&"
export * from "./raca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports